import { Component, inject } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { AuthStore } from "../../stores/auth.store";

@Component({
    selector: "nice-ops-splash",
    imports: [MatProgressBarModule],
    templateUrl: "./splash.template.html",
    styleUrl: "./splash.style.scss"
})
export class SplashComponent {
    protected readonly authStore = inject(AuthStore);
}
